import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ClassroomTypesType } from '../../../types/Classroom';

const initialState:ClassroomTypesType = {
    description: '',
    status: false,
    id: undefined
}

const classroomTypeSlice = createSlice({
  name: "classroomTypeForm",
  initialState,
  reducers: {
    setClassroomTypeData:(state, action:PayloadAction<ClassroomTypesType>)=>({...state, ...action.payload}), 
    resetClassroomTypeData :()=>({...initialState})
  }
});

export const {setClassroomTypeData, resetClassroomTypeData} = classroomTypeSlice.actions

export default classroomTypeSlice.reducer